/**
 * @license
 * @copyright Copyright Motili Inc., 2025 All Rights Reserved
 */

import { useState } from 'react';
import { useAppSelector } from 'common/stores/redux/hooks';
import Alert from 'common/components/Alert';
import {
    updatePassword as AuthServiceUpdatePassword,
    logout as AuthServiceLogout,
} from '../../services/AuthService';
import ChangePassword from './ChangePassword';
import * as AuthService from '../../services/AuthService';
/**
 * Change Password
 *
 */

export default function ChangePasswordContainer() {
    const loading = useAppSelector(state => state.authentication.loading);

    const [password, setPassword] = useState('');
    const [confirmationPassword, setConfirmationPassword] = useState('');
    const [passwordSuccessfullyReset, setPasswordSuccessfullyReset] =
        useState(false);
    const [error, setError] = useState('');

    function handleSubmitPassword(e) {
        e.preventDefault();

        if (!password && !confirmationPassword) {
            return setError('No password specified.');
        }

        if (password !== confirmationPassword) {
            return setError('Passwords do not match.');
        }
        setError(null);

        const token = AuthService.getToken();

        const resetPasswordData = {
            password,
            confirmationPassword,
            token: token.id,
        };

        return AuthServiceUpdatePassword(resetPasswordData)
            .then(async response => {
                setPasswordSuccessfullyReset(true);
                return response;
            })
            .catch(errObject => {
                setError(errObject.message);
                if (errObject.message === 'Invalid token') {
                    Alert.error(
                        'There was an error processing the request, please contact support@motili.com if you need assistance logging into your account.'
                    );
                }
            });
    }

    return (
        <div>
            <ChangePassword
                loading={loading}
                error={error}
                password={password}
                confirmationPassword={confirmationPassword}
                passwordSuccessfullyReset={passwordSuccessfullyReset}
                handlePasswordChange={password => setPassword(password)}
                handleConfirmationPasswordChange={password =>
                    setConfirmationPassword(password)
                }
                handleSubmitPassword={e => handleSubmitPassword(e)}
                handleGoToAccountLogin={() => AuthServiceLogout()}
            />
        </div>
    );
}
